import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { SharedModules } from "src/app/shared.modules";
import { PromptComponent } from "./prompt.component";

@NgModule({
  declarations: [PromptComponent],
  imports: [CommonModule, MatBottomSheetModule, SharedModules],
  exports: [PromptComponent],
})
export class PromptModule {}
